import type { Dict } from './index';

export const tr: Dict = {
  'nav.devices': 'BAĞLI CİHAZLAR',
  'nav.noDevices': 'Henüz bağlı mouse yok.',
  'nav.connect': 'Cihaz bağla',
  'nav.demo': 'Demo mouse ile dene',
  'nav.tools': 'ARAÇLAR',
  'nav.tests': 'Donanım testleri',
  'nav.diagnostics': 'Tanılama',
  'nav.resources': 'KAYNAKLAR',
  'nav.drivers': 'Sürücü indir',
  'nav.support': 'Desteklenen cihazlar',
  'nav.home': 'Ana sayfa',
  'nav.settings': 'Ayarlar',
  'nav.github': 'Kaynak kod',
  'nav.desktop': 'Masaüstü uygulama',
  'common.soon': 'yakında',

  'home.eyebrow': 'Açık kaynak · Kurulum yok · WebHID',
  'home.title': 'Tüm oyuncu mouse’ları için tek kontrol paneli.',
  'home.sub': 'DPI, polling rate, lift-off ve tuş atamalarını doğrudan tarayıcından değiştir. Şişkin üretici yazılımı yok, hesap yok, telemetri yok — ve kodun tamamı GitHub’da.',
  'home.connect': 'Mouse bağla',
  'home.demo': 'Mouse olmadan dene',
  'home.unsupported': 'Tarayıcın WebHID desteklemiyor. Mouse bağlamak için Chrome, Edge, Opera veya başka bir Chromium tabanlı masaüstü tarayıcı kullan. Demo, testler ve sürücü indirme yine de çalışır.',
  'home.f1.t': 'Performans',
  'home.f1.d': 'DPI kademeleri, 8 kHz’e kadar polling rate ve yazmadan önce anlık önizleme.',
  'home.f2.t': 'Sensör ayarı',
  'home.f2.d': 'Lift-off mesafesi, açı düzeltme, ripple control, motion sync ve debounce.',
  'home.f3.t': 'Donanım testleri',
  'home.f3.d': 'Gerçek polling rate’i ölç, çift tıklama arızasını bul, gerçek DPI’ı hesapla.',
  'home.f4.t': 'Sürücü merkezi',
  'home.f4.d': 'Tüm büyük markaların resmi indirme bağlantıları tek, aranabilir bir listede.',
  'home.f5.t': 'Gizlilik öncelikli',
  'home.f5.d': 'Her şey tarayıcında yerel olarak çalışır. Hiçbir veri bilgisayarından çıkmaz.',
  'home.f6.t': 'Genişletilebilir',
  'home.f6.d': 'Sürücüler küçük TypeScript modülleridir. Mouse’unu ekle, pull request aç.',
  'home.how': 'Nasıl çalışır',
  'home.step1': 'Mouse’unu veya kablosuz alıcısını tak.',
  'home.step2': '“Mouse bağla”ya tıkla ve tarayıcı penceresinde seç.',
  'home.step3': 'Ayarları değiştir, önizle ve uygula.',

  'device.tab.overview': 'Genel bakış',
  'device.tab.performance': 'Performans',
  'device.tab.sensor': 'Sensör',
  'device.tab.buttons': 'Tuşlar',
  'device.tab.lighting': 'Aydınlatma',
  'device.tab.profiles': 'Profiller',
  'device.disconnect': 'Bağlantıyı kes',
  'device.refresh': 'Yeniden oku',
  'device.loading': 'Ayarlar mouse’tan okunuyor…',
  'device.notFound': 'Bu cihaz artık bağlı değil.',
  'device.pending': '{n} kaydedilmemiş değişiklik',
  'device.discard': 'Vazgeç',
  'device.apply': 'Değişiklikleri uygula',
  'device.applying': 'Yazılıyor…',
  'device.applied': 'Ayarlar mouse’a yazıldı.',
  'device.applyFailed': 'Ayarlar yazılamadı',
  'device.readFailed': 'Ayarlar okunamadı',
  'device.connected': '{name} bağlandı',
  'device.noSettings': 'Bu mouse’un OpenGlide’da henüz değiştirilebilir ayarı yok.',

  'overview.model': 'Model',
  'overview.vendor': 'Üretici',
  'overview.ids': 'USB kimliği',
  'overview.firmware': 'Yazılım (firmware)',
  'overview.protocol': 'Protokol',
  'overview.connection': 'Bağlantı',
  'overview.driver': 'Sürücü',
  'overview.battery': 'Pil',
  'overview.charging': 'şarj oluyor',
  'overview.dpi': 'Mevcut DPI',
  'overview.rate': 'Polling rate',
  'overview.stages': 'DPI kademeleri',
  'overview.profile': 'Aktif profil',
  'overview.details': 'Cihaz bilgileri',
  'overview.storage': 'Ayarların saklandığı yer',
  'overview.onMouse': 'Mouse’un hafızasında',
  'overview.session': 'Mouse yeniden takılana kadar geçerli',
  'conn.wired': 'Kablolu (USB)',
  'conn.wireless': 'Kablosuz',
  'conn.receiver': '2.4 GHz alıcı',
  'conn.bluetooth': 'Bluetooth',
  'conn.virtual': 'Sanal cihaz',

  'perf.dpi': 'DPI kademeleri',
  'perf.dpiDesc': 'Aktif yapmak için bir kademeye tıkla. Mouse’taki DPI tuşu bunlar arasında geçiş yapar.',
  'perf.dpiSingle': 'Hassasiyet (DPI)',
  'perf.dpiSingleDesc': 'Sensörün inç başına bildirdiği sayım.',
  'perf.stage': 'Kademe {n}',
  'perf.active': 'Aktif',
  'perf.addStage': 'Kademe ekle',
  'perf.remove': 'Kaldır',
  'perf.presets': 'Yaygın değerler',
  'perf.rate': 'Polling rate',
  'perf.rateDesc': 'Mouse’un konumunu ne sıklıkla bildirdiği. Yüksek değer daha akıcıdır ama daha fazla CPU ve pil kullanır.',
  'perf.rateHigh': '1000 Hz üstü değerler güçlü bir işlemci ve doğrudan anakarttaki bir USB portu gerektirir.',

  'sensor.title': 'Sensör',
  'sensor.desc': 'Sensörün takip davranışını ince ayarla.',
  'sensor.lod': 'Lift-off mesafesi',
  'sensor.lodHint': 'Mouse’u kaldırdığında sensörün takibi bıraktığı yükseklik.',
  'lod.Low': 'Düşük',
  'lod.Medium': 'Orta',
  'lod.High': 'Yüksek',
  'sensor.angle': 'Açı düzeltme (angle snapping)',
  'sensor.angleHint': 'Çizgileri düzleştirir. Rekabetçi oyuncuların çoğu kapalı tutar.',
  'sensor.ripple': 'Ripple control',
  'sensor.rippleHint': 'Çok yüksek DPI’da titremeyi yumuşatır, hafif gecikme ekler.',
  'sensor.motion': 'Motion sync',
  'sensor.motionHint': 'Sensör karelerini USB taramasıyla hizalar, girdiyi daha tutarlı yapar.',
  'sensor.debounce': 'Tıklama debounce süresi',
  'sensor.debounceHint': 'Çift tıklama arızasını filtreler. Düşük değer daha hızlıdır.',
  'sensor.sleep': 'Otomatik uyku',
  'sensor.sleepHint': 'Kablosuz mouse’un uykuya geçmeden önceki boşta kalma süresi.',
  'sensor.none': 'Bu mouse sensör ayarı sunmuyor.',

  'buttons.title': 'Tuş atamaları',
  'buttons.desc': 'Her fiziksel tuşun ne yapacağını seç.',
  'buttons.reset': 'Varsayılana döndür',
  'buttons.readOnlyTitle': 'Salt okunur.',
  'buttons.readOnly': 'Bunlar mouse’ta kayıtlı atamalar. Bu sürücü onları okuyabiliyor ama henüz değiştiremiyor.',
  'action.left-click': 'Sol tık',
  'action.right-click': 'Sağ tık',
  'action.middle-click': 'Orta tık',
  'action.back': 'Geri',
  'action.forward': 'İleri',
  'action.dpi-up': 'DPI artır',
  'action.dpi-down': 'DPI azalt',
  'action.dpi-cycle': 'DPI döngüsü',
  'action.scroll-up': 'Yukarı kaydır',
  'action.scroll-down': 'Aşağı kaydır',
  'action.profile-cycle': 'Profil değiştir',
  'action.media-play': 'Oynat / duraklat',
  'action.volume-up': 'Sesi aç',
  'action.volume-down': 'Sesi kıs',
  'action.disabled': 'Devre dışı',

  'light.title': 'Aydınlatma',
  'light.desc': 'Mouse LED’lerinin efekti, rengi ve parlaklığı.',
  'light.effect': 'Efekt',
  'light.color': 'Renk',
  'light.brightness': 'Parlaklık',
  'light.speed': 'Hız',
  'effect.off': 'Kapalı',
  'effect.static': 'Sabit',
  'effect.breathing': 'Nefes',
  'effect.spectrum': 'Spektrum',
  'effect.wave': 'Dalga',

  'profiles.title': 'Dahili profiller',
  'profiles.desc': 'Profiller mouse’un hafızasında saklanır. Geçmek için birine tıkla.',
  'profiles.slot': 'Profil {n}',
  'profiles.backup': 'Yedekle ve geri yükle',
  'profiles.backupDesc': 'Mevcut ayarları dosyaya kaydet veya geri yükle — ayar paylaşmak için de kullanışlı.',
  'profiles.export': 'Ayarları dışa aktar',
  'profiles.import': 'Ayarları içe aktar',
  'profiles.imported': 'Ayarlar yüklendi. Kontrol edip uygula.',
  'profiles.importFailed': 'Bu dosya geçerli bir OpenGlide ayar dosyası değil.',

  'tests.title': 'Donanım testleri',
  'tests.sub': 'Bu testler her mouse ile çalışır — bağlantı gerekmez.',
  'tests.rate': 'Polling rate',
  'tests.rateDesc': 'Mouse’u kutunun içinde hızlıca daireler çizerek hareket ettir.',
  'tests.rateArea': 'Mouse’u burada hareket ettir',
  'tests.current': 'Anlık',
  'tests.average': 'Ortalama',
  'tests.peak': 'En yüksek',
  'tests.reset': 'Sıfırla',
  'tests.click': 'Tıklama testi',
  'tests.clickDesc': 'Alanın içine tıkla. Aralarında {ms} ms’den az olan tıklamalar olası switch arızası (çift tıklama) olarak işaretlenir.',
  'tests.clickArea': 'Buraya tıkla',
  'tests.left': 'Sol',
  'tests.right': 'Sağ',
  'tests.middle': 'Orta',
  'tests.back': 'Geri',
  'tests.forward': 'İleri',
  'tests.chatter': 'Arıza',
  'tests.scroll': 'Tekerlek',
  'tests.scrollDesc': 'Alanın üzerinde tekerleği yukarı ve aşağı çevir.',
  'tests.up': 'Yukarı',
  'tests.down': 'Aşağı',
  'tests.dpi': 'DPI ölçer',
  'tests.dpiDesc': 'Mouse’u bir başlangıç işaretine koy, Başlat’a tıkla, seçilen mesafe kadar sağa kaydır ve tıkla. İşaretçi hızlandırmayı kapat ve işletim sistemi hassasiyetini 1:1 kullan.',
  'tests.distance': 'Mesafe',
  'tests.start': 'Başlat',
  'tests.measuring': 'Şimdi kaydır, bitince tıkla…',
  'tests.result': 'Ölçülen',
  'tests.counts': 'sayım',

  'drivers.title': 'Sürücü indir',
  'drivers.sub': 'Tüm büyük markaların resmi yapılandırma yazılımları. Bağlantılar doğrudan üreticiye gider — OpenGlide dosyaları asla kendisi barındırmaz.',
  'drivers.search': 'Marka veya yazılım ara…',
  'drivers.all': 'Tümü',
  'drivers.web': 'Web tabanlı',
  'drivers.download': 'Resmi indirme',
  'drivers.open': 'Web uygulamasını aç',
  'drivers.openglide': 'OpenGlide’da destekleniyor',
  'drivers.none': 'Aramana uyan marka yok.',
  'drivers.note': 'Bir marka eksik veya bağlantı eski mi? Issue aç ya da apps/web/src/data/drivers.ts dosyasını düzenle.',

  'support.title': 'Desteklenen cihazlar',
  'support.sub': 'OpenGlide’ın bugün konuşabildiği mouse’lar. Topluluk sürücülerine kapımız açık.',
  'support.device': 'Cihaz',
  'support.driver': 'Sürücü',
  'support.status': 'Durum',
  'support.features': 'Özellikler',
  'support.request': 'Mouse iste',
  'support.requestDesc': 'Mouse’u bağla, Tanılama’yı aç ve HID raporunu bir GitHub issue’suna ekle. Yeni bir sürücüye başlamak için genelde bu yeterli.',
  'support.addDriver': 'Sürücü yaz',
  'support.search': 'Marka veya model ara…',
  'support.remapOnly': 'Tuş ataması olanlar',
  'support.count': '{n} aile',
  'status.stable': 'Kararlı',
  'status.beta': 'Beta',
  'status.experimental': 'Deneysel',
  'feature.dpi': 'DPI',
  'feature.pollingRates': 'Polling',
  'feature.liftOff': 'LOD',
  'feature.angleSnapping': 'Açı düzeltme',
  'feature.rippleControl': 'Ripple',
  'feature.motionSync': 'Motion sync',
  'feature.debounce': 'Debounce',
  'feature.sleepTimeout': 'Uyku',
  'feature.lighting': 'RGB',
  'feature.buttons': 'Tuşlar',
  'feature.profiles': 'Profiller',
  'feature.battery': 'Pil',
  'feature.persistent': 'Dahili hafıza',

  'diag.title': 'Tanılama',
  'diag.sub': 'Protokol kaydı ve bağlı cihazların HID yapısı. Hata bildirimlerine ve cihaz isteklerine ekle.',
  'diag.log': 'Protokol kaydı',
  'diag.verbose': 'Paketleri göster',
  'diag.copy': 'Raporu kopyala',
  'diag.download': 'Kaydı indir',
  'diag.clear': 'Temizle',
  'diag.empty': 'Henüz kayıt yok.',
  'diag.collections': 'HID koleksiyonları',
  'diag.copied': 'Panoya kopyalandı.',

  'settings.title': 'Ayarlar',
  'settings.sub': 'Tercihler yalnızca bu tarayıcıda saklanır.',
  'settings.appearance': 'Görünüm',
  'settings.theme': 'Tema',
  'settings.system': 'Sistem',
  'settings.dark': 'Koyu',
  'settings.light': 'Açık',
  'settings.accent': 'Vurgu rengi',
  'settings.language': 'Dil',
  'settings.editing': 'Düzenleme',
  'settings.autoApply': 'Otomatik uygula',
  'settings.autoApplyHint': '“Değişiklikleri uygula”yı beklemeden her değişikliği anında mouse’a yaz.',
  'settings.about': 'Hakkında',
  'settings.aboutText': 'OpenGlide, MIT lisansıyla yayımlanan ücretsiz ve açık kaynaklı bir yazılımdır.',
};
